import Spinner from '@/components/atoms/Spinner'
import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
import { twMerge } from 'tailwind-merge'

export function Hero() {
	const iframeRef = useRef<HTMLIFrameElement>(null)
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		const iframeElement = iframeRef.current

		const handleIframeLoad = () => {
			setIsLoading(false)
		}

		if (iframeElement) {
			iframeElement.addEventListener('load', handleIframeLoad)
		}

		return () => {
			if (iframeElement) {
				iframeElement.removeEventListener('load', handleIframeLoad)
			}
		}
	}, [])

	return (
		<>
			<div
				className={twMerge(
					'hidden justify-center mt-10',
					classNames({ flex: isLoading })
				)}
			>
				<Spinner className='inline w-10 h-10' />
			</div>

			<div className='w-screen h-[calc(100vh-90px)]'>
				<iframe
					ref={iframeRef}
					className={twMerge(
						'w-full h-full block z-50',
						classNames({ hidden: isLoading })
					)}
					title='Map. Habilidades - Fluency'
					src='https://afir.st/wO5iRwsqntxWYmZv'
					loading='eager'
					style={{
						border: 'none',
					}}
				/>
			</div>
		</>
	)
}
